<template>
  <div :style="hostWrapperStyle">
    <DynamicComponentProduction
      v-if="embeddedDcId"
      :dynamic-component-id="embeddedDcId"
      :is-production="renderingInProduction"
      :theme-mode="themeMode"
    />
  </div>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import DynamicComponentProduction
  from "%/dynamic-component-editor/components/DynamicComponentProductionComponent.vue";
import DcHostMixin from "%/dynamic-component-editor/mixins/dc-host-picker-mixin";
import ReferencedComponentId from "%/dynamic-component-editor/options/referenced-component-id";
import ContextBindings from "%/dynamic-component-editor/options/context-bindings";

// Studio renders the "upsell" variant of the subscribe-to-newsletter DC
// (the one shown to logged-out / unsubscribed visitors). The two
// state-switch variants (Subscribed / Subscribed Now) are runtime
// reactions to the visitor's session and don't need an in-canvas
// preview — FanWeb still swaps them at render time via its own
// production renderer.
export default {
  name: "SubscribeToNewsletter",
  components: { DynamicComponentProduction },
  mixins: [DynamicElementMixin, DcHostMixin],
  relatedComponents: [
    "Subscribe To Newsletter",
    "Subscribe To Newsletter Subscribed",
    "Subscribe To Newsletter Subscribed Now",
  ],
  elementPanelSettings: {
    tags: ["newsletter", "subscribe", "email", "signup"],
    displayName: "Subscribe To Newsletter",
    displayIcon: "comment",
    elementGroup: "general",
    elementType: "element",
  },
  options: [ReferencedComponentId, ContextBindings],
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
    }, {
      "layout-height": true,
    }),
  ],
  data() {
    return {
      defaultComponentName: "Subscribe To Newsletter",
    };
  },
};
</script>
